import React, { Component } from "react"

export default class SuccessSubscribe extends Component {
	render() {
		return <div>Success</div>
	}
}
